export const loadScript = (id, src, attributes) => {
  return new Promise((resolve, reject) => {
    if (!document) {
      reject();
    }

    const scriptElement = document.getElementById(id);

    if (scriptElement) {
      resolve();
      return;
    }

    const script = document.createElement('script');

    script.async = true;
    script.id = id;
    script.src = src;

    Object.keys(attributes || {}).forEach((key) => {
      script[key] = attributes[key];
    });

    document.body.appendChild(script);

    script.onload = resolve;
  });
};



// WEBPACK FOOTER //
// ./src/utils/loader.js